// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OperatingBoard_wrapper__1oxVD"};